// extracted by mini-css-extract-plugin
export default {"skeleton150":"CutOffDateAndTime-module_skeleton150_KAHWOelMLT","skeleton100":"CutOffDateAndTime-module_skeleton100_kyrhLYLMx6"};